import React from 'react';
import { useDebug } from '../hooks';
import AddToCartArea from "./AddToCartArea";
import ProductSelect from "./ProductSelect";

const VariableProduct = ({context}: any) => {
  
    const props: any = React.useContext(context);

    useDebug(`VariableProduct [${props.name}]`)

    return (<>
      <ProductSelect {...props} />
      <AddToCartArea {...props} />
    </>)
}

export default VariableProduct;